unable to read source [project]/frontend/node_modules/src/native-bar-code-detector.ts